export class DeviceProfile {
  _id?: string;
  name?: string;
  company?: any;
  variables?: any[];
  class?: string;
}
